import * as React from "react";

function SvgBriefcase({ title, titleId, ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          d="M14.174 2.75a2.75 2.75 0 012.745 2.582l.005.168v1.25H19a2.75 2.75 0 012.745 2.582l.005.168v9a2.75 2.75 0 01-2.582 2.745L19 21.25H5a2.75 2.75 0 01-2.745-2.582L2.25 18.5v-9a2.75 2.75 0 012.582-2.745L5 6.75h2.076V5.5a2.75 2.75 0 012.582-2.745l.168-.005h4.348zm6.076 8.142l-5.188 3.425c-.393.26-.846.413-1.314.448l-.201.007h-3.094c-.472 0-.934-.121-1.343-.35l-.172-.105-5.188-3.424V18.5c0 .648.491 1.18 1.122 1.244L5 19.75h14a1.25 1.25 0 001.244-1.122l.006-.128v-7.608zM19 8.25H5a1.25 1.25 0 00-1.195.883l5.96 3.932c.163.108.349.176.542.198l.146.009h3.094c.196 0 .388-.046.562-.134l.127-.073 5.96-3.932a1.25 1.25 0 00-1.068-.877L19 8.25zm-4.826-4H9.826a1.25 1.25 0 00-1.244 1.122l-.006.128v1.25h6.848V5.5a1.25 1.25 0 00-1.122-1.244l-.128-.006z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgBriefcase;
